import { selector } from 'recoil'
import snackbarState from '../atoms/snackbarAtom'

export const snackbarMessageState = selector({
    key: 'snackbarMessage',
    get: ({ get }) => {
        const snack = get(snackbarState)
        return snack.message
    }
})

export const snackbarStatus = selector({
    key: 'snackbarStatus',
    get: ({ get }) => {
        const snack = get(snackbarState)
        return snack.opened
    }
})
